import { ArrowLeft, ChevronLeft } from "@tamagui/lucide-icons";
import { useContext } from "react";
import type { GetProps } from "tamagui";

import { Button, Text } from "@/components";
import { LayoutContext } from "@/components/LayoutProvider";

export default function BackButton({
  onPress,
  ...props
}: { onPress: () => void } & GetProps<typeof Button.Wrapper>) {
  const { lg } = useContext(LayoutContext);
  if (lg) {
    return (
      <Button.Wrapper
        alignSelf="flex-start"
        aria-label="Back"
        onPress={onPress}
        {...props}
      >
        <ArrowLeft />
      </Button.Wrapper>
    );
  }

  return (
    <Button.Wrapper
      alignSelf="flex-start"
      onPress={onPress}
      aria-label="Back"
      alignItems="center"
      justifyContent="center"
      marginLeft="$-200"
      {...props}
    >
      <ChevronLeft size="$200" marginRight="$100" />
      <Text size="$md">Back</Text>
    </Button.Wrapper>
  );
}
